import { createContext } from "react";

export const PriceTypeContext = createContext({})